export const MARKETPLACE__PERMISSIONS = {
  COURSES_IN_MARKETPLACE: {
    PUBLISH_COURSE_TO_MARKETPLACE: {
      permissionGroupName: 'Publikowanie kursów jako dostępnych do zakupu',
      NONE: {
        dbName: 'MARKETPLACE__COURSES_IN_MARKETPLACE__PUBLISH_COURSE_TO_MARKETPLACE__NONE',
        name: 'Brak uprawnień',
        description: 'Brak możliwości publikowania kursów jako dostępne do zakupu.'
      },
      ENABLED: {
        dbName: 'MARKETPLACE__COURSES_IN_MARKETPLACE__PUBLISH_COURSE_TO_MARKETPLACE__ENABLED',
        name: 'Możliwość publikowania kursów',
        description:
          'Możliwość opublikowania kursu jako publicznie dostępny i możliwy do zakupu przez innych użytkowników.'
      }
    }
  },
  COURSE_CATEGORIES: {
    MANAGE: {
      permissionGroupName: 'Zarządzanie kategoriami kursów',
      NONE: {
        dbName: 'MARKETPLACE__COURSE_CATEGORIES__MANAGE__NONE',
        name: 'Brak uprawnień',
        description:
          'Brak możliwości zarządzania kategoriami kursów dostępnymi na stronie marketingowej.'
      },
      ENABLED: {
        dbName: 'MARKETPLACE__COURSE_CATEGORIES__MANAGE__ENABLED',
        name: 'Możliwość zarządzania kategoriami kursów.',
        description: 'Możliwość zarządzania kategoriami kursów dostępnymi na stronie marketingowej'
      }
    }
  }
} as const
